import { Component } from '@angular/core';
import { ApiUrlHelper } from '../../../../common/api-url-helper';
import { CommonService } from '../../../../services/common/common.service';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { StateService } from '../../../../services/common/claim-year.service';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { commonLabelConstants, ConnectedFormConstants } from '../../../../constants/label-constants';
import { SharedService } from '../../../../services/shared-service/shared.service';
import { Subject, takeUntil } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { ValidationService } from '../../../../services/common/validation-service';

@Component({
  selector: 'app-connected-epw-by-project-form',
  templateUrl: './connected-epw-by-project-form.component.html',
  styleUrl: './connected-epw-by-project-form.component.scss'
})

export class ConnectedEpwByProjectFormComponent {

  env : any = environment;
  projectList: any = [];
  companyId: any = 0
  claimYearId: any = 0;
  epwconnectedRNDForm!: FormGroup;
  detail: any = [];
  isLoading: boolean = false;
  projectProductTotals: number[] = [];
  onDestroy$: Subject<void> = new Subject();
  commonLabelConstants = commonLabelConstants;
  labelConstants = ConnectedFormConstants;
  isLocked: boolean = false;

  constructor(private readonly api: ApiUrlHelper,
    private readonly commonService: CommonService,
    private readonly sharedDataService: StateService,
    private readonly spinner: NgxSpinnerService,
    private readonly fb: FormBuilder,
    private readonly router : Router,
    private readonly toastr: ToastrService,
    private readonly sharedService: SharedService,
    private readonly validationService:ValidationService
  ) {
  }

  get contractor(): FormArray {
    return this.epwconnectedRNDForm.get('contractor') as FormArray
  }

  goBack(): void {
    this.router.navigateByUrl('/dashboard');
  }

  ngOnInit() {

    this.epwconnectedRNDForm = this.fb.group({
      contractor: this.fb.array([])
    });
    this.sharedDataService.companyId$.subscribe((companyId) => {
      this.companyId = companyId;
    });
    this.sharedDataService.yearId$.pipe(takeUntil(this.onDestroy$)).subscribe((yearId) => {
      this.claimYearId = yearId ?? null;

      if (this.companyId && this.claimYearId) {
        this.resetForm();
        this.getProjectListCompanyWise(this.companyId, this.claimYearId)
      }
    });
  }

  resetForm(){
    this.epwconnectedRNDForm = this.fb.group({
      contractor: this.fb.array([])
    });
  }

  getProjectListCompanyWise(companyId: any, claimYearId: any) {
    this.spinner.show();
    let api = this.api.apiUrl.Project.GetProjectListWithOutPagination.replace('{companyId}', companyId).replace('{claimYearId}', claimYearId);
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.projectList = response.data;
        }
        else {
          this.projectList = [];
        }
        this.getContractorDetail();
      },
      error: (error: any) => {
        this.spinner.hide();
        console.log(error);
      }
    });
  }

  calculateSumProduct() {
    const projectCount = this.projectList.length;
    this.projectProductTotals = Array(projectCount).fill(0);

    this.contractor.controls.forEach((contractorGroup: any) => {
      const totalGrossPay = contractorGroup.get('totalGrossPay')?.value || 0;
      const totalGrossPayForNonUk = contractorGroup.get('totalGrossPayForNonUk')?.value || 0;

      const projects = this.getProjectDetails(this.contractor.controls.indexOf(contractorGroup));
      projects.controls.forEach((projectGroup: any, projectIndex: number) => {
        const rndEligibility = projectGroup.get('rndEligibility')?.value || 0;
        this.projectProductTotals[projectIndex] += ((totalGrossPay + totalGrossPayForNonUk) * rndEligibility) / 100;
      });
    });
  }

  createContractor(): FormGroup {
    return this.fb.group({
      epwConnectedId: [null],
      epwConnectedResourceId: [null],
      contractorName: [''],
      jobRole: [''],
      totalGrossPay : [''],
      totalGrossPayForNonUk : [''],
      rationaleForRNDEligibilityAssessment: [''],
      totalEligibilityAmount : [''],
      totalEligibilityAmountForNonUk : [''],
      projects: this.fb.array([])
    });
  }

  createContractorProjectDetail() {
    return this.fb.group({
      epwConnectedEligibilityId: [null],
      epwConnectedResourceId: [null],
      projectId: [''],
      rndEligibility: [''],
    });
  }

  getItemAtIndex(index: number): FormGroup {
    return this.contractor.at(index) as FormGroup;
  }

  getProjectDetails(index: any) {
    return this.getItemAtIndex(index).get('projects') as FormArray;
  }

  getProjectTotal(projectIndex: number): number {
    let total = 0;
    this.contractor.controls.forEach(contractorControl => {
      const projectsArray = contractorControl.get('projects') as FormArray;
      const rndEligibilityValue = projectsArray.at(projectIndex)?.get('rndEligibility')?.value;
      if (rndEligibilityValue) {
        total += parseFloat(rndEligibilityValue);
      }
    });

    return total;
  }

  getUkGrandTotal(): number {
    return this.contractor.controls.reduce((grandTotal, contractorControl, index) => {
      return grandTotal + contractorControl.get('totalEligibilityAmount')?.value;
    }, 0);
  }
  getNonUkGrandTotal(): number {
    return this.contractor.controls.reduce((grandTotal, contractorControl, index) => {
      return grandTotal + contractorControl.get('totalEligibilityAmountForNonUk')?.value;
    }, 0);
  }

  getUkCostTotal(): number {
    return this.contractor.controls.reduce((grandTotal, contractorControl, index) => {
      return grandTotal + contractorControl.get('totalGrossPay')?.value;
    }, 0);
  }
  getNonUkCostTotal(): number {
    return this.contractor.controls.reduce((grandTotal, contractorControl, index) => {
      return grandTotal + contractorControl.get('totalGrossPayForNonUk')?.value;
    }, 0);
  }

  getContractorDetail() {
    this.isLoading = true;
    let obj = {
      companyId: this.companyId,
      claimYearId: this.claimYearId
    }
    let api = this.api.apiUrl.EPWconnectedCostResource.GetEPWconnectedCostResource;
    this.commonService.doPost(api, obj).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.detail = response.data;
          this.isLocked = ( this.detail[0]?.isLocked ?? false);
          this.isLoading = false;
          this.detail.forEach((item: any) => {
            const newContractor = this.createContractor();
            newContractor.patchValue({
              epwConnectedId: item.epwConnectedPartyId,
              contractorName: item.contractorName,
              jobRole: item.jobRole,
              totalGrossPay : item.totalGrossPay,
              totalGrossPayForNonUk: item.totalGrossPayForNonUk,
              totalEligibilityAmount : item.totalEligibilityAmount,
              totalEligibilityAmountForNonUk : item.totalEligibilityAmountForNonUk,
              epwConnectedResourceId: item.epwConnectedResourceId,
              rationaleForRNDEligibilityAssessment: item.rationaleForRNDEligibilityAssessment
            });
            const contractorDetailsArray = newContractor.get('projects') as FormArray;
            this.projectList.forEach((itemDetail: any) => {
              const newProjectDetail = this.createContractorProjectDetail();
              newProjectDetail.patchValue({
                epwConnectedEligibilityId: item.projects.find((projectDetail: any) => projectDetail.projectId == itemDetail.projectId) ? item.projects.find((projectDetail: any) => projectDetail.projectId == itemDetail.projectId).epwConnectedEligibilityId : 0,
                epwConnectedResourceId: item.projects.find((projectDetail: any) => projectDetail.projectId == itemDetail.projectId) ? item.projects.find((projectDetail: any) => projectDetail.projectId == itemDetail.projectId).epwConnectedResourceId : 0,
                projectId: itemDetail.projectId,
                rndEligibility: item.projects.find((projectDetail: any) => projectDetail.projectId == itemDetail.projectId) ? (item.projects.find((projectDetail: any) => projectDetail.projectId == itemDetail.projectId).rndEligibility ?? '0') : '0'
              });
              contractorDetailsArray.push(newProjectDetail);
            });
            this.contractor.push(newContractor);
            this.calculateSumProduct();
          })
        }
        this.spinner.hide();

      },
      error: (error: any) => {
        this.isLoading = false;
        console.log(error);
        this.spinner.hide();
      },
      complete: () => { this.isLoading = false;},
    });
  }

  getRndEligibilitySum(contractorIndex: number): number {
    const projectDetails = this.getProjectDetails(contractorIndex).controls;
    let sum = 0;
    projectDetails.forEach((project: any) => {
      const rndEligibility = project.get('rndEligibility').value ? project.get('rndEligibility').value : 0;
      sum += rndEligibility ? parseFloat(rndEligibility) : 0;
    });
    return sum;
  }
  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  exportList(): void {
    const isValid = this.validationService.validateCompanyAndYear(
      this.companyId,
      this.claimYearId
    );
    if (!isValid) {
      return;
    }
    const companyIdStr = this.companyId !== null ? String(this.companyId) : '';
    const yearIdStr = this.claimYearId !== null ? String(this.claimYearId) : '';
    let obj = {
      CompanyId: companyIdStr,
      ClaimYearId: yearIdStr,
    };
    let api = this.api.apiUrl.EPWconnectedCostResource.ExportEPWconnectedCostCategory;
    this.commonService.doDownloadPost(api, obj).subscribe(
      (response: HttpResponse<Blob>) => {
        const blob = response.body as Blob;
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = "Externally Provided Workers - Connected - Qualifying Expenditure by Cost Category.xlsx";

        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
}
